import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import {
    Alert,
    Box,
    Button,
    Card,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Stack,
    TablePagination,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from "@mui/icons-material/Delete";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import PeopleIcon from "@mui/icons-material/People";
import Usermodify from "src/pages/Management/Usermodify";
import Error403 from "../Error/403";
import Userlabs from "./Userlabs";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export default function Users() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [adminuserlist, setadminuserlist] = useState([]);
    const [opsuserlist, setopsuserlist] = useState([]);
    const [readonlyuserlist, setreadonlyuserlist] = useState([]);
    const [traineruserlist, setTraineruserlist] = useState([]);
    const [traineeuserlist, setTraineeuserlist] = useState([]);

    // Note: These user lists are kept separate as they may be used elsewhere
    // They can be fetched on demand or consolidated later if needed

    const [state, setState] = React.useState({
        email: "",
        username: "",
        groups: "",
        password: "",
        password2: "",
        errorMessage: "",
        right: false,
        radioList: "A",
        delete_id: "",
        active: "1",
        usernameError: false,
        emailError: false,
        passwordError: false,
        passwordMatchError: false,
        groupsError: false,
        formValid: false // Add this
    });

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };


    const handleChange2 = (e) => {
        const { id, value } = e.target;
        // Special validation for email
        if (id === "email") {
            const emailValid = validateEmail(value);
            setState(prev => ({
                ...prev,
                [id]: value,
                emailError: !emailValid
            }));
        }
        // Validation for password fields
        else if (id === "password" || id === "password2") {
            const passwordValid = value.length >= 8; // Minimum 8 characters
            const passwordsMatch = id === "password"
                ? value === state.password2
                : value === state.password;
                
            setState(prev => ({
                ...prev,
                [id]: value,
                passwordError: !passwordValid,
                passwordMatchError: !passwordsMatch
            }));
        }
        // For other fields
        else {
            setState(prev => ({
                ...prev,
                [id]: value
            }));
        }
    };

    const UserNamehandleChange = (e) => {
        const { id, value } = e.target;
        
        // Check if value contains special characters
        const hasSpecialChars = /[^a-zA-Z0-9\s]/.test(value);
        
        setState((prevState) => ({
            ...prevState,
            [id]: value,
            usernameError: hasSpecialChars
        }));
        
        if (!hasSpecialChars) {
            setState((prevState) => ({
                ...prevState,
                [id]: value
            }));
        }
    };

    // Add this useEffect to check form validity whenever state changes
    useEffect(() => {
        const isFormValid = 
            state.email && 
            !state.emailError &&
            state.username && 
            !state.usernameError &&
            state.password && 
            !state.passwordError &&
            state.password2 && 
            !state.passwordMatchError &&
            state.groups;
            
        setState(prev => ({
            ...prev,
            formValid: isFormValid
        }));
    }, [state.email, state.username, state.password, state.password2, state.groups, 
        state.emailError, state.usernameError, state.passwordError, state.passwordMatchError]);

    const handleSubmitClick = (e) => {
        e.preventDefault();
        if (state.password !== state.password2) {
            setState({ errorMessage: "The passwords doesn't match" });
        } else {
            const register = {
                email: state.email,
                username: state.username,
                password: state.password,
                groups: [state.groups],
                is_active: state.active,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
                body: JSON.stringify(register),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.email && data.username) {
                        handleClose();
                        setValue(2);
                    } else {
                        if (data.username) {
                            setState({ email: "" });
                            setState({ username: "" });
                            setState({ password: "" });
                            setState({ password2: "" });
                            setState({ groups: [] });
                            setState({ errorMessage: data.username[0] });
                        } else if (data.email) {
                            if (
                                data.email[0] === "User already exist, It is in Inactive state"
                            ) {
                                handleClickOpenActive();
                            } else if (
                                data.email[0] ===
                                "User already exist, but user not in our organization"
                            ) {
                                handleClickOpenActive();
                            } else {
                                setState({ email: "" });
                                setState({ username: "" });
                                setState({ password: "" });
                                setState({ password2: "" });
                                setState({ groups: [] });
                                setState({ errorMessage: data.email[0] });
                            }
                        } else if (data.password) {
                            setState({ email: "" });
                            setState({ username: "" });
                            setState({ password: "" });
                            setState({ password2: "" });
                            setState({ groups: [] });
                            setState({ errorMessage: data.password[0] });
                        } else {
                            setState({ email: "" });
                            setState({ username: "" });
                            setState({ password: "" });
                            setState({ password2: "" });
                            setState({ groups: [] });
                            setState({ errorMessage: data.errors.email[0] });
                        }
                    }
                })
                .catch((error) => {
                    setState({ errorMessage: "Something Went Wrong" });
                });
        }
    };

    const [userlist, setusers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // const [searchitems, setSearchItems] = React.useState(0);
    const [searchitems, setSearchItems] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, 
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    }
                );
                
                if (!response.ok) {
                    throw new Error("Failed to fetch user data");
                }
                
                const data = await response.json();
                
                if (data.detail) {
                    localStorage.setItem("user_access", data.detail);
                } else {
                    setusers(data);
                }
            } catch (err) {
                setError(err.message || "An error occurred while loading user data");
            } finally {
                setLoading(false);
            }
        };
        
        fetchData();
    }, []);

    // console.log("userlist", userlist);


    const Delete = (UserId) => {
        return function () {
            fetch(
                `${process.env.REACT_APP_API_URL}/api/user_management/user_list/${UserId}/`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: JSON.stringify({ is_active: "0" }),
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    handleCloseDeleteindual();
                    // Refresh user list instead of reloading page
                    // You can add a refresh function here if needed
                })
                .catch((error) => {
                    handleCloseDeleteindual();
                });
            handleCloseDeleteindual();
        };
    };
    const activate = (userId) => {
        return function () {
            const activate = {
                username: state.username,
                password: state.password,
                groups: state.groups.toString(),
                active: state.active,
            };
            fetch(
                `${process.env.REACT_APP_API_URL}/api/user_management/user/${userId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: JSON.stringify(activate),
                }
            )
                .then((response) => response.json())
            .then((data) => { })
            .catch((error) => {
                // Handle error - refresh data instead of reloading page
            });
        };
    };
    const [value, setValue] = React.useState(0);

    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    // };
    // const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);

    // const [alignment, setAlignment] = React.useState("left");

    // const handleChange1 = (value) => {
    //     setAlignment(value);
    // };
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        // window.location.reload(false);
        setState({
            email: "",
            username: "",
            groups: "",
            password: "",
            password2: "",
            errorMessage: "",
            right: false,
            radioList: "A",
            delete_id: "",
            active: "1",
            usernameError: false,
            emailError: false,
            passwordError: false,
            passwordMatchError: false,
            groupsError: false,
            formValid: false
        });
    };
    

    const [opendelete, setOpendelete] = React.useState(false);
    const handleCloseDelete = () => {
        setOpendelete(false);
    };

    const [openactive, setOpenactive] = React.useState(false);

    const handleClickOpenActive = () => {
        setOpenactive(true);
    };

    const handleCloseActive = () => {
        setOpenactive(false);
    };

    const [opencontact, setOpencontact] = React.useState(false);

    const handleCloseContact = () => {
        setOpencontact(false);
    };

    const [opendeleteindual, setOpendeleteindual] = React.useState(false);

    const handleClickOpenDeleteindual = () => {
        setOpendeleteindual(true);
    };

    const handleCloseDeleteindual = () => {
        setOpendeleteindual(false);
    };
    const [useroverview, setuseroverview] = useState(null);
    // Note: useroverview fetch can be added if needed, but it's not used in the visible part

    function del(deleteid) {
        setState({ delete_id: deleteid });
    }

    const handleCloserror = () => {
        setState(prev => ({ ...prev, errorMessage: "" }));
    };


    // Memoized filtered users
    const filteredUsers = useMemo(() => {
        if (!userlist || !Array.isArray(userlist)) return [];
        
        if (!searchitems) {
            return userlist;
        }
        
        const searchTerm = searchitems.toLowerCase();
        return userlist.filter(user => 
            user.email?.toLowerCase().includes(searchTerm) ||
            user.username?.toLowerCase().includes(searchTerm)
        );
    }, [userlist, searchitems]);
      
    // Memoized paginated users
    const paginatedUserList = useMemo(() => {
        return filteredUsers.slice(
            page * rowsPerPage, 
            page * rowsPerPage + rowsPerPage
        );
    }, [filteredUsers, page, rowsPerPage]);

    // Reset pagination when search changes
    useEffect(() => {
        setPage(0);
    }, [searchitems]);

    // Memoized DataGrid columns
    const columns = useMemo(() => [
        { field: 'username', headerName: 'Name', flex: 1, minWidth: 150, headerAlign: 'center', align: 'center' },
        { field: 'email', headerName: 'Email', flex: 1.4, minWidth: 220, headerAlign: 'center', align: 'center' },
        { field: 'edit', headerName: 'Edit', flex: 0.6, minWidth: 120, headerAlign: 'center', align: 'center', renderCell: (params) => <Usermodify UserID={params.row.id} /> },
        {
            field: 'delete', headerName: 'Delete', flex: 0.5, minWidth: 100, headerAlign: 'center', align: 'center', renderCell: (params) => (
                <IconButton
                    aria-label="delete"
                    onClick={() => {
                        handleClickOpenDeleteindual();
                        localStorage.setItem("specifyusername", params.row.email);
                        del(params.row.id);
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            )
        },
        { field: 'details', headerName: 'Details', flex: 0.6, minWidth: 120, headerAlign: 'center', align: 'center', renderCell: (params) => <Userlabs groups={params.row.groups} user_id={params.row.id} /> }
    ], []);

    const handleSearchChange = useCallback((e) => {
        setSearchItems(e.target.value);
    }, []);

    const handleClearSearch = useCallback(() => {
        setSearchItems("");
    }, []);

    const handleChangePage = useCallback((event, newPage) => {
        setPage(newPage);
    }, []);

    const handleChangeRowsPerPage = useCallback((event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }, []);


    return (
        <React.Fragment>
            <Helmet>
                <title>LabAsService - Manage Users</title>
            </Helmet>
            {localStorage.getItem("user_access") ===
                "You do not have permission to perform this action." &&
                localStorage.getItem("group") !== "admin" ? (
                <Error403 />
            ) : (
                <Container maxWidth={false} sx={{ py: 6, pb: 8, px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 } }}>
                    <Card sx={{ mb: 4 }}>
                        {/* Hero Header */}
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, rgba(46,125,50,0.12), rgba(21,101,192,0.12))',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12,
                                p: { xs: 2.5, md: 3 },
                            }}
                        >
                            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <PeopleIcon color="primary" sx={{ fontSize: 32 }} />
                                    <Box>
                                        <Typography variant="h4" component="h1">
                                            Manage Users
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Create, edit, and manage user accounts and permissions
                                        </Typography>
                                    </Box>
                                </Stack>
                                <Tooltip title="Add User" arrow>
                                    <IconButton
                                        sx={{
                                            borderRadius: 2,
                                            px: 2,
                                            py: 1,
                                            backgroundColor: 'primary.main',
                                            color: '#fff',
                                            '&:hover': {
                                                backgroundColor: 'primary.dark',
                                            },
                                        }}
                                        onClick={handleClickOpen}
                                        aria-label="Add User"
                                    >
                                        <PersonAddIcon sx={{ mr: 1 }} />
                                        <Typography variant="body2" sx={{ textTransform: 'none' }}>
                                            Add User
                                        </Typography>
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </Box>

                        <Divider />

                        {/* Error State */}
                        {error && (
                            <Box sx={{ p: { xs: 2.5, md: 3 }, pb: 0 }}>
                                <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
                                    {error}
                                </Alert>
                            </Box>
                        )}

                        <TabPanel value={value} index={0}>
                            <Box sx={{ p: { xs: 2.5, md: 3 } }}>
                                {/* Search and Controls Section */}
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={2}
                                    alignItems={{ xs: 'stretch', sm: 'center' }}
                                    justifyContent="space-between"
                                    sx={{ mb: 3 }}
                                >
                                    <Typography 
                                        variant="h6" 
                                        sx={{ 
                                            fontSize: { xs: '1.1rem', sm: '1.25rem' }, 
                                            fontWeight: 700,
                                            color: 'text.primary'
                                        }}
                                    >
                                        Users
                                    </Typography>
                                    <TextField
                                        placeholder="Search by Email or Username"
                                        value={searchitems}
                                        onChange={handleSearchChange}
                                        size="small"
                                        sx={{
                                            width: '100%',
                                            maxWidth: { xs: '100%', sm: 400, md: 500 },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            endAdornment: searchitems && (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        size="small"
                                                        onClick={handleClearSearch}
                                                        aria-label="clear search"
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Stack>
                            <Box>
                                <Dialog
                                    open={open}
                                    onClose={(event, reason) => {
                                        // Only allow closing through the cancel button
                                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                                            return;
                                        }
                                        handleClose();
                                    }}
                                    aria-labelledby="form-dialog-title"
                                    fullScreen={fullScreen}
                                    fullWidth
                                    maxWidth="sm"
                                >
                                    <DialogTitle id="form-dialog-title">CREATE USER</DialogTitle>
                                    {state.errorMessage && (
                                        <Box sx={{ px: 3, pt: 1 }}>
                                            <Alert
                                                severity="error"
                                                onClose={handleCloserror}
                                                sx={{ mb: 2 }}
                                            >
                                                {state.errorMessage}
                                            </Alert>
                                        </Box>
                                    )}
                                    <DialogContent>
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="email"
                                            label="Email Address"
                                            type="email"
                                            fullWidth
                                            name="email"
                                            value={state.email}
                                            onChange={handleChange2}
                                            autoComplete="new-email"
                                            for="email"
                                            required
                                            error={state.emailError}
                                            helperText={state.emailError ? "Please enter a valid email address" : ""}
                                        />
                                        <TextField
                                            for="username"
                                            id="username"
                                            autoFocus
                                            margin="dense"
                                            label="Name*"
                                            type="text"
                                            fullWidth
                                            value={state.username}
                                            onChange={UserNamehandleChange}
                                            name="username"
                                            error={state.usernameError}
                                            helperText={state.usernameError ? "Special characters are not allowed" : ""}
                                        />
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            label="Password*"
                                            fullWidth
                                            for="password"
                                            type="password"
                                            autoComplete="new-password"
                                            name="password"
                                            id="password"
                                            value={state.password}
                                            onChange={handleChange2}
                                            error={state.passwordError}
                                            helperText={state.passwordError ? "Password must be at least 8 characters" : ""}
                                        />
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            label="Confirm Password*"
                                            fullWidth
                                            for="password2"
                                            type="password"
                                            autoComplete="new-password"
                                            name="password2"
                                            id="password2"
                                            value={state.password2}
                                            onChange={handleChange2}
                                            error={state.passwordMatchError}
                                            helperText={state.passwordMatchError ? "Passwords do not match" : ""}
                                        />
                                    </DialogContent>{" "}
                                    <DialogContent>
                                        <Grid item md={13} xs={12}>
                                            <TextField
                                                fullWidth
                                                label="Groups"
                                                name="groups"
                                                id="groups"
                                                onChange={handleChange2}
                                                required
                                                select
                                                SelectProps={{ native: true }}
                                                value={state.groups}
                                                variant="outlined"
                                                error={state.groupsError}
                                                helperText={state.groupsError ? "Please select a group" : ""}
                                            >
                                                <option></option>
                                                <option value="1">Admin</option>
                                                <option value="2">Read-Only</option>
                                                <option value="3">OPS</option>
                                                <option value="4">Trainer</option>
                                                <option value="5">Trainee</option>
                                            </TextField>
                                        </Grid>
                                    </DialogContent>
                                    <DialogActions>
                                        <Tooltip title="Cancel" arrow>
                                            <Button onClick={handleClose} color="primary">
                                                Cancel
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Create" arrow>
                                            <span>
                                                <Button
                                                    type="submit"
                                                    onClick={handleSubmitClick}
                                                    color="primary"
                                                    disabled={!state.formValid}
                                                >
                                                    Create
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </DialogActions>
                                </Dialog>
                            </Box>
                            <Box>
                                <Dialog
                                    open={opendelete}
                                    onClose={handleCloseDelete}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    fullScreen={fullScreen}
                                    fullWidth
                                    maxWidth="xs"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        Are you sure you want to delete the User{" "}
                                        <Typography component="strong" sx={{ color: "#EF5350" }}>
                                            {localStorage.getItem("specifyusername")}
                                        </Typography>{" "}
                                        ?
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description"></DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Tooltip title="Disagree" arrow>
                                            <Button onClick={handleCloseDelete} color="primary">
                                                Disagree
                                            </Button>
                                        </Tooltip>
                                        <Tooltip title="Agree" arrow>
                                            <Button
                                                onClick={Delete(state.delete_id)}
                                                color="primary"
                                                autoFocus
                                            >
                                                Agree
                                            </Button>
                                        </Tooltip>
                                    </DialogActions>
                                </Dialog>
                            </Box>
                            <Box>
                                <Dialog
                                    open={openactive}
                                    onClose={handleCloseActive}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    fullScreen={fullScreen}
                                    fullWidth
                                    maxWidth="xs"
                                >
                                    {userlist.map((userlist) => {
                                        return (
                                            <React.Fragment key={userlist.id}>
                                                {userlist.email === state.email ? (
                                                    <React.Fragment>
                                                        <DialogTitle id="alert-dialog-title">
                                                            User already exist, It is in Inactive state. if
                                                            you want to Activate the account, Please Click
                                                            Activate
                                                            <Typography component="strong" sx={{ color: "#EF5350" }}>
                                                                {" "}
                                                                {state.email}
                                                            </Typography>{" "}
                                                            ?
                                                        </DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText id="alert-dialog-description"></DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Tooltip title="Cancel" arrow>
                                                                <Button
                                                                    onClick={handleCloseActive}
                                                                    color="primary"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Activate" arrow>
                                                                <Button
                                                                    onClick={activate(userlist.id)}
                                                                    color="primary"
                                                                    autoFocus
                                                                >
                                                                    Activate
                                                                </Button>
                                                            </Tooltip>
                                                        </DialogActions>
                                                    </React.Fragment>
                                                ) : (
                                                    ""
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </Dialog>
                            </Box>
                            <Box>
                                <Dialog
                                    open={opencontact}
                                    onClose={handleCloseContact}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    fullScreen={fullScreen}
                                    fullWidth
                                    maxWidth="xs"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        User is Inactive, Please Contact
                                        <Typography component="strong">
                                            <a
                                                href="mailto:support@zippyops.com"
                                                style={{ marginLeft: "5px", color: "#2096ff", textDecoration: "none" }}
                                            >
                                                support@zippyops.com
                                            </a>
                                        </Typography>
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description"></DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Tooltip title="Close" arrow>
                                            <Button onClick={handleCloseContact} color="primary">
                                                Close
                                            </Button>
                                        </Tooltip>
                                    </DialogActions>
                                </Dialog>
                            </Box>
                        </Box>

                        {/* Data Grid Section */}
                        <Box sx={{ p: { xs: 2.5, md: 3 }, pt: 0 }}>
                            {loading ? (
                                <Box>
                                    <Skeleton variant="rectangular" height={400} sx={{ mb: 2 }} />
                                    <Skeleton variant="rectangular" height={60} />
                                </Box>
                            ) : filteredUsers.length > 0 ? (
                                <Box
                                    sx={{
                                        width: '100%',
                                        overflow: 'hidden',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 1,
                                    }}
                                >
                                    <DataGrid
                                        rows={paginatedUserList.filter(customer => customer.is_active === true || String(customer.is_active).toLowerCase() === "true")}
                                        columns={columns}
                                        autoHeight
                                        hideFooter
                                        disableColumnMenu
                                        sx={{
                                            '& .MuiDataGrid-row:hover': {
                                                backgroundColor: 'action.hover',
                                            },
                                            '& .MuiDataGrid-cell': {
                                                borderBottom: '1px solid',
                                                borderColor: 'divider',
                                            },
                                            '& .MuiDataGrid-columnHeaders': {
                                                backgroundColor: 'action.hover',
                                                borderBottom: '2px solid',
                                                borderColor: 'divider',
                                                fontWeight: 600,
                                            },
                                        }}
                                    />
                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 50, 75, 100]}
                                        component="div"
                                        count={filteredUsers.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        sx={{
                                            borderTop: '1px solid',
                                            borderColor: 'divider',
                                            '& .MuiTablePagination-toolbar': {
                                                justifyContent: 'flex-start',
                                                paddingLeft: 2,
                                            },
                                            '& .MuiTablePagination-spacer': {
                                                display: 'none',
                                            },
                                            '& .MuiTablePagination-selectLabel': {
                                                margin: 0,
                                            },
                                            '& .MuiTablePagination-displayedRows': {
                                                margin: 0,
                                            },
                                        }}
                                    />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: 300,
                                        color: 'text.secondary',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 1,
                                    }}
                                >
                                    <PeopleIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
                                    <Typography variant="h6" gutterBottom>
                                        {userlist.length === 0 
                                            ? 'No users available' 
                                            : 'No matching users found'}
                                    </Typography>
                                    <Typography variant="body2" align="center" sx={{ maxWidth: 400, mt: 1 }}>
                                        {userlist.length === 0
                                            ? 'No users found. Click "Add User" to create a new user account.'
                                            : `No users match your search "${searchitems}". Try adjusting your search terms.`}
                                    </Typography>
                                </Box>
                            )}
                            <Box>
                                            <Dialog
                                                open={opendeleteindual}
                                                onClose={handleCloseDeleteindual}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description"
                                                fullScreen={fullScreen}
                                                fullWidth
                                                maxWidth="xs"
                                            >
                                                <DialogTitle id="alert-dialog-title">
                                                    Are you sure you want to delete the User{" "}
                                                    <Typography component="strong" sx={{ color: "#EF5350" }}>
                                                        {localStorage.getItem("specifyusername")}
                                                    </Typography>{" "}
                                                    ?
                                                </DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-description"></DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Tooltip title="Cancel" arrow>
                                                        <Button
                                                            onClick={handleCloseDeleteindual}
                                                            color="primary"
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip title="Confirm" arrow>
                                                        <Button
                                                            onClick={Delete(state.delete_id)}
                                                            color="primary"
                                                            autoFocus
                                                        >
                                                            Confirm
                                                        </Button>
                                                    </Tooltip>
                                                </DialogActions>
                                            </Dialog>
                            </Box>
                        </Box>
                    </TabPanel>
                    </Card>
                </Container>
            )}
        </React.Fragment>
    );
}
